module.exports = __webpack_public_path__ + "static/media/wh1.2ead1b3c.svg";